export enum DocumentationIssue {
  INCORRECT = 'Incorrect',
  MISSING = 'Missing',
  OTHER = 'Other',
}
